
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/best-bets",
      function () {
        return require("private-next-pages/[league]/best-bets/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/best-bets"])
      });
    }
  